import React from 'react';
import { Smartphone } from 'lucide-react';
import { useUnsyncedDevices } from '../../hooks/useUnsyncedDevices';

export const UNSYNCED_HINT_TEXT = 'Unsynced work on your phone or tablet — open pelora there to sync.';

export interface UnsyncedWorkHintProps {
  /** Show only when this patient has unsynced work (needs patientIds from the server) */
  patientId?: string;
  /** Show only when one of these visits is unsynced */
  visitIds?: string[];
  className?: string;
}

/**
 * Phase 16C C10: on a laptop or a second device, a visit that exists only on the clinician's phone
 * isn't listed until it syncs. This line says so (ids only). With no filter it shows whenever any
 * other device holds unsynced work.
 */
const UnsyncedWorkHint: React.FC<UnsyncedWorkHintProps> = ({ patientId, visitIds, className = '' }) => {
  const unsynced = useUnsyncedDevices();
  if (!unsynced.any) return null;
  if (patientId && unsynced.patientIds.size > 0 && !unsynced.patientIds.has(patientId)) return null;
  if (visitIds && !visitIds.some((id) => unsynced.visitIds.has(id))) return null;
  return (
    <p role="status" className={`flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 ${className}`}>
      <Smartphone size={16} className="shrink-0" aria-hidden="true" />{UNSYNCED_HINT_TEXT}
    </p>
  );
};

export default UnsyncedWorkHint;
